export default __webpack_public_path__ + "static/media/ic_search.3c9db8db.svg";